import { render } from "./cargarArchivo.vue?vue&type=template&id=f10b20d4&scoped=true"
import script from "./cargarArchivo.vue?vue&type=script&lang=js"
export * from "./cargarArchivo.vue?vue&type=script&lang=js"

import "./cargarArchivo.vue?vue&type=style&index=0&id=f10b20d4&scoped=true&lang=css"
import "./cargarArchivo.vue?vue&type=style&index=1&id=f10b20d4&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.41_vue@3.5.41_webpack@5.109.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f10b20d4"]])

export default __exports__